

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-modifica-preventivo-fase1",
    templateUrl: "./dialog-modifica-preventivo.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogModificaPreventivoFase1 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected cambiaPreventivoForm: FormGroup;
    protected filePreventivo: File;
    protected isCambiandoPreventivo:boolean = false;
    

    protected label:string="Cerca file del preventivo";
    protected icona:string="";
    protected stile:string="btn-choose-file-preventivo";
    protected filePreventivoClass:string="btn-choose-file-preventivo";

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.cambiaPreventivoForm = this.formBuilder.group({
        preventivo:             new FormControl({value: this.pratica.preventivo, disabled: true}, Validators.required),
        nuovoPreventivo:        [ null, [Validators.required]]
      });
      
    }
  
    ngOnInit(): void {
    }

    onPreventivoFileUpload($event){

    }

    onPreventivoFileSelect($event: { files: File[]; }) {
      this.label = 'File del preventivo caricato';
      this.icona = "pi pi-check";
      this.filePreventivoClass = "btn-preventivo-upload-success";
      this.filePreventivo = $event.files[0];
      this.logger.info(this.filePreventivo);
    }  

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isCambiandoPreventivo = true;
        let nuovoPreventivo: PreventivoFase1DTO = new PreventivoFase1DTO();
        nuovoPreventivo.preventivo = this.cambiaPreventivoForm.value.nuovoPreventivo;
        this.praticheService.modificaPreventivo(this.pratica.id, nuovoPreventivo).subscribe( {
            next: (res) => {

              if(this.filePreventivo!=null){
                const fileName = this.pratica.cui + "/IN/FASE_1/preventivo/" + this.pratica.cui+".pdf";
                this.googleStorageService
                .uploadFileScuolaToGoogleStorage(this.filePreventivo, fileName)
                .then((uploadRes) => {
                  this.praticheService.comunicaCaricamentoFilePreventivo(this.pratica.id).subscribe({
                    next: (res) => {  
                      this.isCambiandoPreventivo = false;
                  
                      this.dialogRef.close({ success: true});
                    },
                    error: (e) => {
                      this.isCambiandoPreventivo = false;
                      this.dialogRef.close({ success: false});
                      this.messageService.add({
                        severity: "info",
                        summary: "Errore" , life:10000,
                          detail: "Errore in fase di caricamento del nuovo file del preventivo!",
                        });
                    },
                    complete: () => {
        
                    }
                  });
                
                })
                .catch((errore) => {
                  this.messageService.add({
                    severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Errore in fase di caricamento del file del preventivo!",
                    });
                  
                  this.dialogRef.close({ success: false });
                });
              }else{
                this.isCambiandoPreventivo = false;
                this.dialogRef.close({ success: true });
              }

              
            },  error: (e) => {
              this.isCambiandoPreventivo = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di aggiornamento del preventivo!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        );
       // this.praticheService.comunicaEsitoSopralluogo(this.pratica.id, esito).subscribe( {
        /* let esito:SopralluogoFase1DTO = new SopralluogoFase1DTO();
        esito.dataEsecuzione                = this.comunicaEsitoSopralluogoForm.value.dataEsecuzione;
        esito.noteSopralluogo               = this.comunicaEsitoSopralluogoForm.value.noteSopralluogo;
        esito.sopralluogoConEsitoPositivo   = this.comunicaEsitoSopralluogoForm.value.esito==='OK';
       
        if(this.lavoriNecessari){
          esito.necessarieOpereExtra = true;
          esito.preventivoOpereExtra = this.lavoriExtraForm.value.preventivo;
          esito.noteOpereExtra       = this.lavoriExtraForm.value.noteLavoriExtra;
        }

        if(this.permessoNecessario){
          esito.necessariaRichiestaPermesso = true;
          esito.noteRichiestaPermesso       = this.permessoForm.value.notePermesso;
        }

        this.praticheService.comunicaEsitoSopralluogo(this.pratica.id, esito).subscribe( {
            next: (res) => {
              //caricamento file + aggiornamento firestore
              if(this.filePreventivo!=null){
                const fileName = this.pratica.cui + "/IN/FASE_1/preventivo/" + this.pratica.cui+".pdf";
                this.googleStorageService
                .uploadFileScuolaToGoogleStorage(this.filePreventivo, fileName)
                .then((uploadRes) => {
                  this.praticheService.comunicaCaricamentoFilePreventivo(this.pratica.id).subscribe({
                    next: (res) => {  
                      this.isComunicandoEsitoSopralluogo = false;
                  
                      this.dialogRef.close({ success: true});
                    },
                    error: (e) => {
                      this.isComunicandoEsitoSopralluogo = false;
                      this.dialogRef.close({ success: false});
                      this.messageService.add({
                        severity: "info",
                        summary: "Errore" , life:10000,
                          detail: "Errore in fase di comunicazione dell'avvenuto caricamento del preventivo!",
                        });
                    },
                    complete: () => {
        
                    }
                  });
                
                })
                .catch((errore) => {
                  this.messageService.add({
                    severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Errore in fase di caricamento del file del preventivo!",
                    });
                  
                  this.dialogRef.close({ success: false });
                });
              }else{
                this.isComunicandoEsitoSopralluogo = false;
                this.dialogRef.close({ success: true });
              }
             
            },
            error: (e) => {
              this.isComunicandoEsitoSopralluogo = false;
            },
            complete: () => {

            }
        });*/
      } 
    }
  
  }